import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon
    {...props}
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.49999 3.66667C4.03975 3.66667 3.66666 4.03977 3.66666 4.50001V11.5C3.66666 11.9603 4.03975 12.3333 4.49999 12.3333H11.5C11.9602 12.3333 12.3333 11.9603 12.3333 11.5V4.50001C12.3333 4.03976 11.9602 3.66667 11.5 3.66667H4.49999ZM2.66666 4.50001C2.66666 3.48748 3.48747 2.66667 4.49999 2.66667H11.5C12.5125 2.66667 13.3333 3.48749 13.3333 4.50001V11.5C13.3333 12.5125 12.5125 13.3333 11.5 13.3333H4.49999C3.48747 13.3333 2.66666 12.5126 2.66666 11.5V4.50001Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.25218 5.39907C6.40812 5.31009 6.59979 5.31154 6.75435 5.40288L10.421 7.56954C10.5733 7.6595 10.6667 7.82318 10.6667 8.00001C10.6667 8.17683 10.5733 8.34051 10.421 8.43047L6.75435 10.5971C6.59979 10.6885 6.40812 10.6899 6.25218 10.6009C6.09625 10.512 5.99999 10.3462 5.99999 10.1667V5.83334C5.99999 5.6538 6.09625 5.48805 6.25218 5.39907ZM6.99999 6.70956V9.29045L9.18382 8.00001L6.99999 6.70956Z"
      fill="currentColor"
    />
  </SvgIcon>
));
